import Draggable from "react-draggable";
import { useDispatch, useSelector } from "react-redux";
import { quickInputSelector, setExpand, showQuickInput } from "./reducers/QuickInputReducer";
import TonnageQuickInput from "./TonnageQuickInput";
import './QuickInput.scss';
import { ComponentType } from "../SavedSearch/SavedSearch";
import { Button } from "@mui/material";
import CargoQuickInput from "./CargoQuickInput";

const QuickInput: React.FunctionComponent = () => {
    let dispatch = useDispatch();
    let quickInputData = useSelector(quickInputSelector);

    const renderBody = () => {
        switch (quickInputData.componentType) {
            case ComponentType.Tonnage:
                return <TonnageQuickInput></TonnageQuickInput>;
            case ComponentType.Cargo:
                return <CargoQuickInput></CargoQuickInput>
            default:
                <></>
        }
    }

    return (
        <>
            {
                quickInputData.showQuickInput &&
                <div className="quick-input">
                    <div className="quick-input-header">
                        <div className="quick-input-title">
                            {quickInputData.componentType?.toString()}
                        </div>

                        <div className="quick-input-action-button">
                            <Button
                                variant="contained"
                                className="accordion-collapse-button"
                                onClick={() => {
                                    dispatch(showQuickInput(false));
                                }}
                                tabIndex={-1}
                            >
                                <i className="fa fa-times" aria-hidden="true"></i>
                            </Button>
                        </div>
                    </div>
                    <div className="quick-input-body">
                        {renderBody()}
                    </div>
                </div>
            }

        </>
    )
};

export default QuickInput;